export default __webpack_public_path__ + "8cdf6b83f5ce396ab9571cf86973afef.png";